import React from 'react'
import Shopping from "../assets/illustrations/shopping.gif"
import Delivery from "../assets/illustrations/delivery.gif"
import Handy from "../assets/illustrations/handy.gif"
import Car from "../assets/illustrations/car.gif"

function FeatureArea() {
  return (
    <div className="feature-area pt-120">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 mx-auto">
                    <div className="site-heading text-center">
                        {/* <span className="site-title-tagline">Services</span> */}
                        <h2 className="site-title">Our Services</h2>
                        <div className="heading-divider"></div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-3">
                    <div className="feature-item wow fadeInUp" data-wow-delay=".25s">
                        <div className="feature-icon">
                            <img src={Car} alt="TaxiDo Service Icon" />
                        </div>
                        <div className="feature-content">
                            <h4>TaxiDo</h4>
                            <p>Get around with ease! TaxiDo offers a reliable and efficient platform for booking rides anytime, anywhere.</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-3">
                    <div className="feature-item mt-lg-5 wow fadeInDown" data-wow-delay=".25s">
                        <div className="feature-icon">
                            <img src={Handy} alt="Handyman Service Icon" />
                        </div>
                        <div className="feature-content">
                            <h4>FixSwift ( Handyman)</h4>
                            <p>connects you to a pool of top notch skilled artisans.</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-3">
                    <div className="feature-item wow fadeInUp" data-wow-delay=".25s">
                        <div className="feature-icon">
                            <img src={Shopping} alt="Online Shopping Icon" />
                        </div>
                        <div className="feature-content">
                            <h4>ShopSwift</h4>
                            <p>Enjoy a seamless shopping experience! ShopSwift lets you browse and order products online with just a few clicks.</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-3">
                    <div className="feature-item mt-lg-5 wow fadeInDown" data-wow-delay=".25s">
                        <div className="feature-icon">
                            <img src={Delivery} alt="Delivery Service Icon" />
                        </div>
                        <div className="feature-content">
                            <h4>DropSwift</h4>
                            <p>Fast and reliable! SwiftDelivery ensures your items are delivered safely and on time, wherever you need them.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FeatureArea